export default __webpack_public_path__ + "296640c6f4d1d252c1ac9b4878d29cc0.mp3";